<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup" :title="'CADASTRO EVENTOS - FOLLOWUP'" :showClearButton="true" :showSaveButton="true"
      :showBackButton="true" v-on:Clear="onClear" v-on:Back="onBack" v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtGroup"><small class="text-danger">*</small> Tipo de Evento:</label>
          <div class="input-group">
            <b-form-select v-model="form.tpEventoId.value" :options="form.tpEventoId.options" class="mb-3">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtName"><small v-show="form.nome.required" class="text-danger">*</small> Nome do Evento:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite o Nome do Evento'" v-model="form.nome.value"
              :size="form.nome.maxlength" :required="form.nome.required" :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group checkbox-row">
        <div>
          <label><small v-show="form.deslocamento.required" class="text-danger">*</small>Requer Deslocamento?</label>
          <div class="input-group">
            <b-form-checkbox v-model="form.deslocamento.value" value="true" unchecked-value="false">
              <span style="padding-top: 3px; display: block;">Sim</span>
            </b-form-checkbox>
          </div>
        </div>
        <div>
          <label><small v-show="form.despesa.required" class="text-danger">*</small>Requer Despesa?</label>
          <div class="input-group">
            <b-form-checkbox v-model="form.despesa.value" :value="true" :unchecked-value="false">
              <span style="padding-top: 3px; display: block;">Sim</span>
            </b-form-checkbox>
          </div>
        </div>
        <div>
          <label><small v-show="form.agendamento.required" class="text-danger">*</small>Requer Agendamento?</label>
          <div class="input-group">
            <b-form-checkbox v-model="form.agendamento.value" :value="true" :unchecked-value="false">
              <span style="padding-top: 3px; display: block;">Sim</span>
            </b-form-checkbox>
          </div>
        </div>
        <div>
          <label><small v-show="form.visita.required" class="text-danger">*</small>Visita?</label>
          <div class="input-group">
            <b-form-checkbox v-model="form.visita.value" :value="true" :unchecked-value="false">
              <span style="padding-top: 3px; display: block;">Sim</span>
            </b-form-checkbox>
          </div>
        </div>
        <div>
          <label><small v-show="form.contato.required" class="text-danger">*</small>Realiza Contato?</label>
          <div class="input-group">
            <b-form-checkbox v-model="form.contato.value" :value="true" :unchecked-value="false">
              <span style="padding-top: 3px; display: block;">Sim</span>
            </b-form-checkbox>
          </div>
        </div>
        <div>
          <label><small v-show="form.contatoPositivo.required" class="text-danger">*</small>Contato Positivo?</label>
          <div class="input-group">
            <b-form-checkbox v-model="form.contatoPositivo.value" :value="true" :unchecked-value="false">
              <span style="padding-top: 3px; display: block;">Sim</span>
            </b-form-checkbox>
          </div>
        </div>
        <div>
          <label><small v-show="form.followupRapido.required" class="text-danger">*</small>Follow-up Rápido?</label>
          <div class="input-group">
            <b-form-checkbox v-model="form.followupRapido.value" :value="true" :unchecked-value="false">
              <span style="padding-top: 3px; display: block;">Sim</span>
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import EventModel from '@/shared/models/configurations/eventmodel.js'
import EventForms from './event-form.js'
import EventRepository from '@/shared/http/repositories/configurations/event.js'
import EventTypeRepository from '@/shared/http/repositories/configurations/eventtype.js'

export default {
  name: 'EventAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: EventModel,
      form: EventForms
    }
  },
  created () {
    this.onLoadAllEventType()
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () { },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      if (obj && obj.tipoEventoDTO) {
        this.form.tpEventoId.value = obj.tipoEventoDTO.id
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      this.data.inative = false
      this.data.tpEventoId = this.form.tpEventoId.value
      this.data.visita = !!this.form.visita.value
      this.data.agendamento = !!this.form.agendamento.value
      this.data.deslocamento = !!this.form.deslocamento.value
      this.data.despesa = !!this.form.despesa.value
      this.data.contato = !!this.form.contato.value
      this.data.contatoPositivo = !!this.form.contatoPositivo.value
      this.data.followupRapido = !!this.form.followupRapido.value
      EventRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.inative = false
      this.data.tpEventoId = this.form.tpEventoId.value
      this.data.visita = !!this.form.visita.value
      this.data.agendamento = !!this.form.agendamento.value
      this.data.deslocamento = !!this.form.deslocamento.value
      this.data.despesa = !!this.form.despesa.value
      this.data.contato = !!this.form.contato.value
      this.data.contatoPositivo = !!this.form.contatoPositivo.value
      this.data.followupRapido = !!this.form.followupRapido.value
      EventRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onLoadAllEventType () {
      loading.push()
      EventTypeRepository.GetAll()
        .then((response) => {
          this.form.tpEventoId.options = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}
</script>

<style>
.checkbox-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.checkbox-row>div {
  flex: 0 0 13.5%;
  min-width: 120px;
}

@media (max-width: 768px) {
  .checkbox-row>div {
    flex: 0 0 48%;
  }
}

@media (max-width: 480px) {
  .checkbox-row>div {
    flex: 0 0 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/events/components/add/eventadd.vue